//components
import Grid from "@mui/material/Grid";
import Button from "@mui/material/Button";

//providers
import { getAuthCookie } from "lib/Storage";

const styles = {
  button: {
    backgroundColor: "#55ff5500",
    color: "#00FF00",
    borderColor: "#00FF00",
    borderWidth: "1px",
    borderStyle: "solid",
    margin: "1%",
    padding: "1%",
    height: "100%",
    width: "100%",
    font:"Iransans"
  },
};

function Navigator(props) {
  const { setRightState } = props;

  return (
    <>
      {
        <Grid
          Container
          style={{
            height: "100%",
            alignSelf: "center",
          }}
        >
          <Grid
            container
            columnSpacing={2}
            style={{
              width: "100%",
              height: "100%",
              alignItems: "center",
              justifyContent: "space-evenly",
              marginLeft: 0,
              paddingRight: "3%",
            }}
          >
            <Grid
              item
              container
              xs={12}
              spacing={0.5}
              style={{ height: "45%", justifyContent: "space-evenly" }}
            >
              <Grid item xs={5}>
                {getAuthCookie() ? (
                  <Button
                    type="submit"
                    size="large"
                    style={styles.button}
                    variant="contained"
                    onClick={() => {
                      setRightState("timelines");
                    }}
                  >
                    Timelines
                  </Button>
                ) : (
                  <Button
                    type="submit"
                    size="large"
                    style={styles.button}
                    variant="contained"
                    onClick={() => {
                      setRightState("login");
                    }}
                  >
                    Login
                  </Button>
                )}
              </Grid>
              <Grid item xs={5}>
                <Button
                  type="submit"
                  size="large"
                  style={styles.button}
                  variant="contained"
                  onClick={() => {
                    setRightState("goto");
                  }}
                >
                  Jump to
                </Button>
              </Grid>
            </Grid>
            <Grid
              item
              container
              xs={12}
              spacing={0.5}
              style={{ height: "45%", justifyContent: "space-evenly" }}
            >
              <Grid item xs={5}>
                <Button
                  //   type="submit"
                  size="large"
                  style={styles.button}
                  sx={{ width: "100%", height: "100%" }}
                  variant="contained"
                  onClick={() => {
                    setRightState("search");
                  }}
                >
                  Search
                </Button>
              </Grid>
              <Grid item xs={5}>
                <Button
                  //   type="submit"
                  size="large"
                  style={{...styles.button,
                  fontSize:"xx-large",
                  fontFamily:"Irannastaliq",
                  lineHeight:"unset"
                  }}
                  sx={{ width: "100%", height: "100%" }}
                  variant="contained"
                  onClick={() => {
                    // console.log("Divine!");
                    setRightState("divine");
                  }}
                >
                     فال
                </Button>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      }
    </>
  );
}

export default Navigator;
